import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp, FiX } from 'react-icons/fi';
import { animated, useSpring } from 'react-spring';

import styles from './mobileAsideWrapper.module.css';

const MobileAsideWrapper = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const animation = useSpring({
    visibility: fadeIn ? 'visible' : 'hidden',
    opacity: isOpen ? 1 : 0,
  });

  function open() {
    setIsOpen(true);
    setFadeIn(true);
  }

  function close() {
    setIsOpen(false);
    setTimeout(() => setFadeIn(false), 200);
  }

  return (
    <>
      <button
        onClick={isOpen ? close : open}
        className={styles.button}
        aria-label="Chevron Toggle"
      >
        {isOpen ? (
          <FiX fontSize="24px" />
        ) : (
          <>
            <FiChevronUp fontSize="18px" />
            <FiChevronDown fontSize="18px" />
          </>
        )}
      </button>
      <animated.div className={styles.aside} style={animation}>
        <div>{children}</div>
      </animated.div>
    </>
  );
};

export default MobileAsideWrapper;
